import lf from 'lovefield'

export function const_constantes (schemaBuilder) {
  schemaBuilder.createTable('const_constantes')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('nbMaxEchelons', lf.Type.INTEGER)
      .addColumn('heuresJour', lf.Type.NUMBER)
      .addColumn('longueurMaxChantier', lf.Type.NUMBER)
      .addColumn('dureeMaxChantier', lf.Type.INTEGER)
      .addColumn('contenanceBungalow', lf.Type.INTEGER)
      .addColumn('largeurChantier', lf.Type.NUMBER)
      .addColumn('prixLitreCarburant', lf.Type.NUMBER)
      .addColumn('kgCO2ParLitreCarburant', lf.Type.NUMBER)
      .addColumn('epaisseurReglage', lf.Type.NUMBER)
      .addColumn('efficienceCompacteurs', lf.Type.NUMBER)
      .addColumn('depassementAutorise', lf.Type.NUMBER)
    /*
      .addColumn('constCO2Deblai', lf.Type.INTEGER)
      .addColumn('constCO2Compactage', lf.Type.INTEGER)
      */
      .addColumn('constCO2Max', lf.Type.INTEGER)

      .addColumn('ratiosM3FIN', lf.Type.NUMBER)
      .addColumn('ratiosM3IO', lf.Type.NUMBER)
      .addColumn('ratiosM3FG', lf.Type.NUMBER)
      .addColumn('ratiosM3ROC', lf.Type.NUMBER)
    /*    this.ratiosM3 = {"FIN":3.4,"IO":3.4,"FG":3.4,"ROC":4.7}; */
      .addColumn('ratioChaux', lf.Type.NUMBER)
      .addColumn('ratioKM', lf.Type.NUMBER)
      .addColumn('constBonusRatio', lf.Type.NUMBER)
      .addColumn('penalitesMontant', lf.Type.NUMBER)
      .addColumn('penalitesPlafond', lf.Type.NUMBER)


      .addPrimaryKey(['id'])
      .addNullable(['nbMaxEchelons', 'heuresJour', 'longueurMaxChantier', 'dureeMaxChantier', 'contenanceBungalow',
        'efficienceCompacteurs', 'depassementAutorise',  /*'constCO2Deblai', 'constCO2Compactage', */ 'constCO2Max','ratiosM3FIN','ratiosM3IO','ratiosM3FG','ratiosM3ROC','ratioChaux','ratioKM','constCO2Max','constBonusRatio','penalitesMontant','penalitesPlafond']);
}




// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constConstantes.schema.js